module.exports = __webpack_public_path__ + "static/media/arrow-circle-up-outline.810e49dd.svg";